import { CheckCircle, Shield, Layers, LayoutGrid } from "lucide-react";
import { COPY } from "@/content/copy";

const benefits = COPY.whyFlexaura.reasons.map((reason, index) => ({
  icon: [CheckCircle, Shield, Layers, LayoutGrid][index],
  title: reason.title,
  description: reason.description,
}));

const WhyFlexauraSection = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-semibold mb-4 text-primary">
            {COPY.whyFlexaura.title}
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            The smart way to pay monthly for travel, education, and healthcare in UAE
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex gap-4 p-6 rounded-2xl card-shadow hover:elevated-shadow smooth-transition bg-card">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-xl bg-primary/10 border border-border flex items-center justify-center">
                  <benefit.icon className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-heading font-semibold mb-2">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground font-body">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-8">
          <p className="text-xs text-muted-foreground font-body">
            Eligibility and limits are determined by the financing provider.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyFlexauraSection;